import { render, staticRenderFns } from "./Doughnut.vue?vue&type=template&id=f9388180&scoped=true"
import script from "./Doughnut.vue?vue&type=script&lang=js"
export * from "./Doughnut.vue?vue&type=script&lang=js"
import style0 from "./Doughnut.vue?vue&type=style&index=0&id=f9388180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9388180",
  null
  
)

export default component.exports